document.addEventListener('click', function (e) {
    if (e.target.closest('.js_cart--remove')) {
        e.preventDefault();
        console.log('product removed')
        var isCartPage = document.body.getAttribute('data-cart-template');
        console.log(isCartPage)
        let currentEm = e.target.closest('.js_cart--remove');
        let key = currentEm.getAttribute('data-item-key');
        let updatedQty = 0;
        let currentItem = {};
        let parentWithUid = currentEm.closest('[data-uid]');
       
        let currentUID = parentWithUid ? parentWithUid.getAttribute('data-uid') : "";
        if (currentUID.trim() !== "") {
            document.querySelectorAll(`[data-uid='${currentUID}']`).forEach((el) => {
                let key2 = el.getAttribute('data-key');
                currentItem[key2] = updatedQty;
                
            });
          
        } else {
            currentItem[key] = updatedQty;
        }
  
        console.log('current_item', currentItem);
  
        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates: currentItem })
        })
        .then(response => response.json())
        .then(data => {
          if (isCartPage === 'true') {
            $('#cart_form').submit();
          }else{
         window.PXUTheme.jsAjaxCart.updateView();
        }
            
        })
        .catch(error => console.error(error));
    }
  });